/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Awaiting_Activation_HintInputs */



/**
* | output |
* | --- |
* | "Your account is ready — you will be able to sign in as soon as it is activated." |
*
* @param {Org_Awaiting_Activation_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_awaiting_activation_hint = /** @type {((inputs?: Org_Awaiting_Activation_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Awaiting_Activation_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Konto ist eingerichtet — Sie können sich anmelden, sobald die Aktivierung erfolgt ist.")
	return /** @type {LocalizedString} */ ("Your account is ready — you will be able to sign in as soon as it is activated.")
});